import { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { LEGAL } from "../config/legal";
import {
  UserIcon,
  ServerStackIcon,
  ShieldCheckIcon,
  CakeIcon,
  DocumentDuplicateIcon,
} from "@heroicons/react/24/outline";

export default function MentionsLegales() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.hash) {
      navigate(`/${location.hash}`, { replace: true });
    }
  }, [location, navigate]);

  return (
    <main className="min-h-screen bg-gradient-to-br from-gray-900/80 via-gray-900/60 to-gray-800/80 backdrop-blur-xl flex flex-col items-center justify-center p-8 pt-32">
      <div className="max-w-2xl w-full">
        <h1 className="text-4xl font-extrabold mb-8 text-center text-primary-300">
          Mentions légales
        </h1>
        <div className="space-y-6">
          {/* Éditeur du site */}
          <section className="rounded-2xl bg-white/10 dark:bg-gray-900/20 shadow-lg border border-white/20 p-6 flex gap-4 items-center">
            <UserIcon className="w-8 h-8 text-fuchsia-400 shrink-0" />
            <div>
              <h2 className="text-xl font-semibold mb-2 text-white">Éditeur du site</h2>
              <p className="text-gray-300">
                <strong>Nom de l'application :</strong> MP3 Random Selector
                <br />
                <strong>Responsable de la publication :</strong> {LEGAL.seller.name}
                <br />
                <strong>Statut :</strong> {LEGAL.seller.status}
                <br />
                <strong>SIRET :</strong> {LEGAL.seller.siret}
                <br />
                <strong>TVA :</strong> {LEGAL.vat}
                <br />
                <strong>Contact :</strong> {LEGAL.seller.email}
                <br />
                <strong>Adresse :</strong> {LEGAL.seller.address}
                <br />
              </p>
            </div>
          </section>
          {/* Hébergement */}
          <section className="rounded-2xl bg-white/10 dark:bg-gray-900/20 shadow-lg border border-white/20 p-6 flex gap-4 items-center">
            <ServerStackIcon className="w-8 h-8 text-pink-400 shrink-0" />
            <div>
              <h2 className="text-xl font-semibold mb-2 text-white">Hébergement</h2>
              <p className="text-gray-300">
                <strong>Hébergeur :</strong> Vercel
                <br />
                <strong>Adresse de l'hébergeur :</strong> 340 S Lemon Ave #4133,
                Walnut, CA 91789, États-Unis
                <br />
                <strong>Téléphone :</strong> N/A
                <br />
              </p>
            </div>
          </section>
          {/* Données personnelles */}
          <section className="rounded-2xl bg-white/10 dark:bg-gray-900/20 shadow-lg border border-white/20 p-6 flex gap-4 items-center">
            <ShieldCheckIcon className="w-8 h-8 text-fuchsia-400 shrink-0" />
            <div>
              <h2 className="text-xl font-semibold mb-2 text-white">Données personnelles</h2>
              <p className="text-gray-300">
                Les informations personnelles collectées via l'application ou le
                site (adresse e-mail, nom, licences achetées, informations
                d'activation de l'application) sont utilisées uniquement pour
                gérer votre compte et vos licences. Conformément au Règlement
                Général sur la Protection des Données (RGPD), vous disposez d'un
                droit d'accès, de rectification, d'opposition et de suppression
                de vos données. Vous pouvez supprimer votre compte depuis la page
                Profil. Pour toute autre demande, contactez :
                {" "}{LEGAL.seller.email}.
                <br />
                Pour fonctionner, le service s'appuie sur des prestataires qui
                traitent une partie de ces données : Supabase (base de données et
                authentification), Stripe (paiement, vos coordonnées bancaires ne
                transitent jamais par nos serveurs), Vercel (hébergement du
                site) et Cloudflare (réseau et mesure d'audience anonyme). Vos
                données ne sont ni vendues ni cédées à d'autres tiers.
                <br />
                Pour le détail des données, des durées de conservation et de vos
                droits, consultez la{" "}
                <Link to="/confidentialite" className="underline text-purple-300">
                  politique de confidentialité
                </Link>
                .
              </p>
            </div>
          </section>
          {/* Cookies */}
          <section className="rounded-2xl bg-white/10 dark:bg-gray-900/20 shadow-lg border border-white/20 p-6 flex gap-4 items-center">
            <CakeIcon className="w-8 h-8 text-pink-400 shrink-0" />
            <div>
              <h2 className="text-xl font-semibold mb-2 text-white">Cookies</h2>
              <p className="text-gray-300">
                Ce site n'utilise aucun cookie publicitaire et ne réalise aucun suivi publicitaire. La session de
                connexion à votre compte est conservée dans le stockage de votre navigateur : elle est nécessaire
                au fonctionnement du site. Lors du paiement, Stripe peut déposer des traceurs destinés à prévenir
                la fraude. La fréquentation du site est mesurée de façon anonyme, sans cookie, par Cloudflare Web
                Analytics. Pour en savoir plus, consultez la{" "}
                <Link to="/confidentialite" className="underline text-purple-300">
                  politique de confidentialité
                </Link>
                .
              </p>
            </div>
          </section>
          {/* Propriété intellectuelle */}
          <section className="rounded-2xl bg-white/10 dark:bg-gray-900/20 shadow-lg border border-white/20 p-6 flex gap-4 items-center">
            <DocumentDuplicateIcon className="w-8 h-8 text-fuchsia-400 shrink-0" />
            <div>
              <h2 className="text-xl font-semibold mb-2 text-white">Propriété intellectuelle</h2>
              <p className="text-gray-300">
                L'ensemble des contenus (textes, images, logos, etc.) présents sur
                ce site et dans l'application sont protégés par le droit d'auteur.
                Toute reproduction, représentation ou diffusion, totale ou
                partielle, sans autorisation expresse, est interdite.
              </p>
            </div>
          </section>
        </div>
        <p className="text-gray-400 text-sm text-center mt-8">
          Dernière mise à jour : 7 octobre 2026
        </p>
      </div>
    </main>
  );
}
